module.exports = __webpack_public_path__ + "img/logo-medcury.3bd78213.png";